import {
  CONFORMING_LOAN_TYPE,
  CONVENTIONAL_LOAN_TYPE_FILTER_VALUE,
  FHA_LOAN_TYPE_FILTER_VALUE,
  NON_CONFORMING_LOAN_TYPE,
} from './constants'

export const loanTypesList = [CONVENTIONAL_LOAN_TYPE_FILTER_VALUE, FHA_LOAN_TYPE_FILTER_VALUE]

export const CONVENTIONAL_LOAN_TYPE_LIST = [CONFORMING_LOAN_TYPE, NON_CONFORMING_LOAN_TYPE]
